/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkip2ForwardIcon16Regular = forwardRef('MediaUiASkip2ForwardIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 3.5a.75.75 0 0 0-1.5 0v3.099L9.099 2.998A1.35 1.35 0 0 0 7 4.12v2.144L2.099 2.998A1.35 1.35 0 0 0 0 4.12v7.758a1.35 1.35 0 0 0 2.099 1.123L7 9.735v2.144a1.35 1.35 0 0 0 2.099 1.123l5.401-3.6V12.5a.75.75 0 0 0 1.5 0v-9Zm-14.5.901V11.6L6.898 8 1.5 4.401Zm7 0V11.6L13.898 8 8.5 4.401Z" })));
});
